import {
  Directive,
  ElementRef,
  AfterViewInit,
  NgZone
} from '@angular/core';



/**
 *  A directive that can put the focus on the given element.
 *  SOMETIMES the following is needed else it triggers 'touched' on the first input:
 * 
            <!-- needed else auto focus hits a control with validation and thus touches it resulting in errors.-->
            <input hidden>
 */
@Directive({
    selector: '[Focus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
  constructor(private el: ElementRef, private zone: NgZone) { }
  ngAfterViewInit() {
    // Gebruik NgZone om focus buiten Angular change detection te doen
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this) {
          this.el?.nativeElement?.focus();
        }
      }, 100);
    });
  }

}